import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
import {
  Grid,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import Button from "components/CustomButtons/Button.jsx";
import InlineDatePicker from "../../utils/InlineDatePicker"
import {appConstants} from "../../_constants";
import AutocompleteSelect from "../../utils/AutocompleteSelect";


const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200
  },
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: "center",
    color: theme.palette.text.secondary
  },
  formRoot: {
    display: "flex",
    flexWrap: "wrap"
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2
  },
  searchButton: {
    backgroundColor: " #66bb6a"
  },
  airlineSelect: {
    marginTop: "0px",
    width: '100%'
  }
});

function InvoiceApprovalPanel(props) {
  const { user, classes, selectChange, data, startDate,
    handleDateChange, endDate, startLabel, endLabel, locationData,
    airportLocation, AirlineId, dateType, dateTypes,statusTypes,
    status, onSearch} = props;
  
  return (
    <div className={classes.root}>
      <Grid container spacing={24}>
        <Grid item lg={3}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              Airlines
            </InputLabel>
            <AutocompleteSelect
              options={data.map(option => ({ value: option.AirlineId, label: option.Airline }))}
              selectedOption={AirlineId}
              handleSelectChange={(e, name) => selectChange(e, name)}
              // selectLabel={"Airlines"}
              disabled={user.AppRole === appConstants.ROLES.AIRLINE}
              name={"AirlineId"}
            />
          </FormControl>
        </Grid>
        <Grid item lg={3}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              Airports
            </InputLabel>
            <AutocompleteSelect
              options={locationData.map(option => ({ value: option.Code, label: option.Name }))}
              selectedOption={airportLocation}
              handleSelectChange={(e, name) => selectChange(e, name)}
              selectLabel={"Airports"}
              disabled={user.AppRole === appConstants.ROLES.AIRPORT_MANAGER || (user.Location)}
              name={"airportLocation"}
            
            />
          </FormControl>
        </Grid>
        <Grid item lg={2}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              Date Types
            </InputLabel>
            <AutocompleteSelect
              options={dateTypes.map(option => ({ value: option.Id, label: option.name }))}
              selectedOption={dateType}
              handleSelectChange={(e, name) => selectChange(e, name)}
              // selectLabel={"Date Types"}
              name={"dateType"}
      
            />
          </FormControl>
        </Grid>
        <Grid item lg={3}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              Status
            </InputLabel>
            <AutocompleteSelect
              options={statusTypes.map(option => ({value: option.value, label: option.name}))}
              name={"status"}
              selectedOption={status}
              handleSelectChange={(e, name) => selectChange(e, name)}
            />
          </FormControl>
        </Grid>
        <Grid item lg={4}>
          <div className="picker">
            <InlineDatePicker
              Date={startDate}
              handleDateChange={(date) => handleDateChange(date, 'startDate')} label={startLabel}/>
          </div>
        </Grid>
        <Grid item lg={4}>
          <div className="picker">
            <InlineDatePicker Date={endDate}  handleDateChange={(date) => handleDateChange(date, 'endDate')} label={endLabel}/>
          </div>
        </Grid>
        <Grid item lg={2}>
          <Button color={'regional'} onClick={() => onSearch()}>Search</Button>
        </Grid>
      </Grid>
    </div>
  );
}

export default withStyles(styles)(InvoiceApprovalPanel);



// WEBPACK FOOTER //
// ./src/Regional-Views/InvoiceApproval/searchPanel.js